import { makeStyles } from '@material-ui/core';
import { isRtl } from 'helpers/device_helper';

export default makeStyles((theme) => ({
    theme_switch_wrapper: {
        position: 'relative',
        cursor: 'pointer',
        height: '40px',
        width: '72px',
        borderRadius: '20px',
        border: `1px solid ${theme.palette.type === 'dark' ? 'rgba(255, 255, 255, 0.23)' : 'rgba(0, 0, 0, 0.23)'}`,
        backgroundColor: 'transparent',
        outline: 0,
    },
    theme_switch_circle: {
        position: 'absolute',
        left: theme.palette.type === 'dark' ? '100%' : '5px',
        right: theme.palette.type === 'dark' ? '5px' : '100%',
        transform: `translateX(${theme.palette.type === 'dark' ? 'calc(-100% - 5px)' : '0'}) translateY(-50%) rotate(${
            theme.palette.type === 'dark' ? '0deg' : '-360deg'
        })`,
        ...isRtl({
            transform: `translateX(${
                theme.palette.type === 'dark' ? '0' : 'calc(100% + 5px)'
            }) translateY(-50%) rotate(${theme.palette.type === 'dark' ? '0deg' : '-360deg'})`,
        }),
        transition: 'all 500ms linear',
        top: '50%',
        borderRadius: '50%',
        height: '30px',
        width: '30px',
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '4px',
        overflow: 'hidden',
    },
}));
